<template>
  <div class="app" style="padding-top:60px;" v-if="wxFalg">
      <div class="top">
            <img :style='mystyle' src="../assets/img2/lo.png" alt="" srcset="">
            <!-- <van-button type="default" @click="getLanguage(types)" style="right:60px">
               <span >{{nemeType}}</span>
            </van-button> -->
            <van-button type="default" style="width: 40px;" @click="isSearch()">
                 <van-icon name="search" />
            </van-button>
      </div>
      <div class="sear" v-if="issearchType">
        <form action="/">
            <van-search
                v-model="searchvalue"
                placeholder="请输入搜索关键词"
                show-action
                shape="round"
                @search="onSearch"
              >
                <div slot="action" @click="onSearch">搜索</div>
            </van-search>
        </form>
      </div>
      
      <van-cell-group>
        <van-cell>
          <h4 style="margin:0;font-size: 0.34rem;color: #444;height: 0.6rem;line-height: 0.6rem;">目录/<span style="font-size:0.2rem;color:#666;">Catalog</span></h4>
        </van-cell>
        <!-- <van-cell v-for="(item,index) in Catalog" :key="index" @click="golist(item.id)" >  -->
          <!-- <div class="image">
            <img :src="item.img" alt="图片">
            <div></div>
          </div>
          <h5>{{item.menus_name}}</h5>
          <div><van-icon name="arrow" /><span>{{More}}</span></div> -->
          <!-- <div class="list">
            <div class="list-cent ">
              <p class="ziti2" style="font-size:0.26rem;line-height: .3rem;color:#4c4948;letter-spacing:1px; font-weight:700;">{{item.chn}}</p>
              <p class="ziti" style="font-size:0.2rem;line-height: .24rem;color:#666464l">{{item.eng}}</p>
            </div>
             <div class="list-nub ziti2">
                0{{index+1}}
            </div>
          </div>
        </van-cell> -->
      </van-cell-group>
      <van-collapse v-model="activeName" accordion class="menuBox">
        <van-collapse-item v-for="(item,index) in Catalog" :key="index" :name="index">
          <template #title>
              <div>{{item.chn}}</div>
          </template>
          <div v-for="(item2,index2) in item.children" :key="index2">
            <p @click="golist(item2.id,item.id)">{{item2.menus_name}}</p>
          </div>
        </van-collapse-item>
      </van-collapse>  
      <van-overlay :show="show2">
          <van-loading type="spinner" color="#fff"  style="z-index:99;"/>
      </van-overlay>
      <div style="padding: 0.6rem 0;margin: 0rem 14px;position: relative;">
         <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
            <!-- slides -->
            <swiper-slide>
              <img  @click="golist(Catalog[0].id)" src="../assets/img3/1.jpg" alt="" srcset="">
            </swiper-slide>
            <swiper-slide>
              <img @click="golist(Catalog[1].id)" src="../assets/img3/2.jpg" alt="" srcset="">
            </swiper-slide>
            <swiper-slide>
              <img @click="golist(Catalog[2].id)" src="../assets/img3/3.jpg" alt="" srcset="">
            </swiper-slide>
            <swiper-slide>
              <img @click="golist(Catalog[3].id)" src="../assets/img3/4.jpg" alt="" srcset="">
            </swiper-slide>
            <swiper-slide>
              <img @click="golist(Catalog[4].id)" src="../assets/img3/5.jpg" alt="" srcset="">
            </swiper-slide>
            <swiper-slide>
              <img @click="golist(Catalog[5].id)" src="../assets/img3/6.jpg" alt="" srcset="">
            </swiper-slide>
            <swiper-slide>
              <img @click="golist(Catalog[6].id)" src="../assets/img3/7.jpg" alt="" srcset="">
            </swiper-slide>
            <swiper-slide>
              <img @click="golist(Catalog[7].id)" src="../assets/img3/4.jpg" alt="" srcset="">
            </swiper-slide>
            <!-- Optional controls -->
            <!-- <div class="swiper-pagination"  slot="pagination"></div> -->
            <!-- <div class="swiper-scrollbar"   slot="scrollbar"></div> -->
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
      </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import $ from 'jquery'
export default {
  name: 'App',
  data() {
    return {
      activeName: '0',
      value1: '',
      value2: 'a',
       show: false,
       searchvalue:'',
       types:1,
       datas:'',
       show2:false,
       nemeType:'ENG',
       More:'了解更多',
       issearchType:false,
       Catalog:[],
      mystyle:{marginTop: '10px'},
      swiperOption: {
        slidesPerView : 4, 
        //loop : true, 
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        callback:function(s){
           console.log(s)
        },
          // some swiper options/callbacks
          // 所有的参数同 swiper 官方 api 参数
          // ...
      },
      imgUrl:require("../assets/img2/lo3.jpg"),
      wxFalg:false,
    }
  },
  created(){
   
    this.wxFalg = true;
    this.show2 =true;
    this.getData()
    this.initWx()
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // alert('是否是iOS：'+isiOS);
    if(isiOS){
      if(window.localStorage.getItem('wxNum')){
          this.wxFalg = true;
          window.localStorage.clear()
          //console.log(2)
        }else{
          window.localStorage.setItem('wxNum','b')
          window.location.reload()
        // console.log(1)
        }
    }else{
       this.wxFalg = true;
    }
    
  },
  computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
  },
  methods: {
    callback(){

    },
    isSearch(){
      this.issearchType = true;
    },
    hide(){
        this.show = false;
    },
    showPopup() {
      this.show = true;
    },
    golist(data,pid){
      console.log(data)
      
      this.$router.push({
        path: '/LIST',
        query: {
          id:data,
          pid:pid,
          types:this.types
          },
        })
      this.show = false;
    },
    onCancel(){

    },
    getLanguage(type){
      this.Catalog = [];
      if(this.types == 1){
        this.types = 2;
        this.nemeType = '中文'
        this.More = 'More'
        console.log(this.types+this.nemeType)
      }else if (this.types== 2){
        this.types = 1;
        this.nemeType = 'ENG'
        this.More = '了解更多'
        console.log(this.types+this.nemeType)
      }
      this.getData()
    },
    getData(){
      let _this = this;
      let zz,dd;
      this.$http({method:"GET",url:"/index.php/App/AjaxPublic/index?types=1"})
          .then(
            res=>{
              console.log(res)
            //  _this.show2 = false
            zz = res.data.data;
            this.$http({method:"GET",url:"/index.php/App/AjaxPublic/index?types=2"})
                .then(
                  res=>{
                    console.log(res)
                  _this.show2 = false
                  //_this.datas = res.data.data;
                  dd = res.data.data;
                  for(let i = 0; i<dd.length;i++){
                    let cat ={
                      eng:dd[i].menus_name,
                      chn:zz[i].menus_name,
                      children:zz[i].children,
                      pid:zz[i].children.id,
                      id:zz[i].id
                    }
                    _this.Catalog.push(cat)
                }
                console.log(this.Catalog)
              }
            )
         }
      )
    },
    onSearch(){
      if(this.searchvalue == ''){
        this.$router.push({path: '/LIST',query: {types:this.types,search:'12357'}}) 
      }else{
        this.$router.push({path: '/LIST',query: {types:this.types,search:this.searchvalue }}) 
      }
        
    },
    initWx(){
      var _this = this
      var randNumber = Math.floor(Math.random() * 100000 + 1);
     var getWxData = '';
	    $.post(this.baseUrl+"/index.php/App/AjaxPublic/getWxData",{"request_url":window.location.href},function(res){
	     if(res.code == 1){
	    	 getWxData = res.data;
	    	 console.log(getWxData);
	    	 wx.config ({  
                 debug : false,    // true:调试时候弹窗  
                 appId : getWxData.appId,  // 微信appid  
                 timestamp : getWxData.timestamp, // 时间戳  
                 nonceStr : getWxData.nonceStr,  // 随机字符串  
                 signature :getWxData.signature, // 签名  
                 jsApiList : [  
                     // 所有要调用的 API 都要加到这个列表中  
                     'onMenuShareTimeline',   // 分享到朋友圈接口  
                     'onMenuShareAppMessage', //  分享到朋友接口  
                     'onMenuShareQQ',         // 分享到QQ接口  
                     'onMenuShareWeibo'       // 分享到微博接口  
                 ]  
             });  
             wx.ready (function () {  
                  // 微信分享的数据  
                  var shareData = {  
                    "imgUrl" :"http://project.tsinghua-auto.cn/Public/Xinwen/fenxiang/fenxiang.jpg?v="+randNumber,     // 分享显示的缩略图地址  
                     "link"  : window.location.href,// 分享地址  
                     "desc"  : "清华大学苏州汽车研究院最新技术成果展示",   // 分享描述  
                     "title" : "成果汇编",   // 分享标题  
                     success : function () {  

                      }   
                  };   
                    wx.onMenuShareTimeline (shareData);   
                    wx.onMenuShareAppMessage (shareData);   
                    wx.onMenuShareQQ (shareData);   
                    wx.onMenuShareWeibo (shareData);  
             });  
              
             wx.error(function(res){   
                //console.log(res);
                //alert(JSON.stringify(res));
             });  
	     }else{
         }
     },"JSON");  
    }
  },
  mounted() {
      // current swiper instance
      // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
      //console.log('this is current swiper instance object', this.swiper)
      this.swiper.slideTo(1, 1000, false)
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isiOS){
        this.mystyle.marginTop = '9px'
      }
    
    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.top{
    background: #fff;
    position: fixed;
    height: 60px;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    text-align: left;
    top: 0;
    left: 0;
    z-index: 10;
}
.top img{
    width: 50%;
    margin-left: 20px;
    height: 38px;
}
.van-overlay{
  z-index: 11 !important;
}
.top button{
    position: absolute;
    right: 15px;
    top: 12px;
    width: 70px;
    padding: 0;
  
}
.van-cell__value--alone{
 text-align: center
}
.top2{
  width: 100%;
  overflow: hidden;
}
.top2>div:nth-child(1){
  float: left;
  width: 98%;
}
.top2>div:nth-child(2) button {
    margin-left: 30px;
    margin-top: 10px;
}
.van-button{
  height: 36px;
  line-height: 36px;
}
.popup_box{
    padding: 15px 20px;
    position: relative;
}
.popup_box span:nth-child(3){
    position: absolute;
    right: 10px;
    top: 10px;
}
.popup_box span:nth-child(3) i{
    font-size: 18px;
    padding-top: 5px;
}
.popup_box{
  font-size: 16px;
}
.popup_box span{
  display: inline-block;
  margin: 0px 10px
}
.van-loading {
    color: #c8c9cc;
    font-size: 0;
    width: 80px;
    height: 80px;
    /* background: rgba(255,255,255,.7); */
    text-align: center;
    line-height: 80px;
    top: 38%;
    margin: auto;
}
h5{
  margin: 0
}
.van-cell__value--alone{
  text-align: left
}
.van-cell__value--alone img{
  width: 100%;
  max-height: 200px;
  min-height: 150px;
  display: block;
}
.van-cell__value--alone h5{
  font-size: 15px
}
.van-cell__value--alone i{
  position: relative;
  top: 2px;
}
.sear{
   margin-bottom: 10px;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      border-width: 0;
}
.van-cell__value--alone h5 {
 font-size: 22px;
 position: absolute;
 bottom: 50px;
 left: 16px;
 color: #fff;
}
.image{
  position: relative;
}
.image div{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.4);
}
.list{
  overflow: hidden;
  display: flex;
}
.list-nub{
  float: left;
  width: 14%;
  height: 100%;
  color:#4c4948;
  font-size: 0.2rem;
  line-height: 0.8rem;
  text-align: center;
  /* letter-spacing: -4px; */
  align-self: center;
  border-left: 1px solid #c5c5c5;
  font-weight: bold;
}
.list-cent{
  float: right;
  width: 84%;
  padding-top: 0.14rem;
  padding-left: 0.14rem;
}
.list-cent p{
 margin: 0;
  /*font-family:"Microsoft YaHei",微软雅黑;
 font-family:"黑体"; */
  /* font-family:"Sans-serif"; */
 
}
.van-cell:not(:last-child)::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 14px;
    bottom: 0;
    left:14px;
    border-bottom: 1px solid #bdbdbd;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
}
.swiper-slide {
    height: 1.3rem!important;
}
.swiper-slide img{
    width: 98%!important;
    height: 1.3rem!important;
    
}
.swiper-button-prev{
   background-image:url("../assets/img3/rt.png")!important;
    height: 1.3rem!important;
    width: 12px!important;
    left: -0.22rem!important;
    background-size: auto!important;
    top: 0.6rem!important;
    margin-top: 0!important;
    border-radius: 0.08rem;
}
.swiper-button-next{
   background-image:url("../assets/img3/lt.png")!important;
    height: 1.3rem!important;
    width: 12px!important;
    right: -0.22rem!important;
    background-size: auto!important;
    top: 0.6rem!important;
    margin-top: 0!important;
    border-radius: 0.08rem;
}
.swiper-wrapper {
    /* //left: 25%!important; */
}
.ziti{
  font-family:Arial,-apple-system, BlinkMacSystemFont, "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif;
}
.ziti2{
  font-family:Helvetica, Arial, Helvetica, sans-serif;
}
/* .van-cell{
  line-height: .3rem;
  padding:0.14rem 0.16rem;
} */
/* .menuBox{
   line-height: .3rem;
  padding:0.14rem 0.16rem; 

} */
.van-collapse-item__title{
  font-size:0.26rem;color:#4c4948;letter-spacing:1px; font-weight:700;
}
.van-collapse-item__content p{
  margin:0;
  padding:0;
  line-height:2.5;
  font-size:0.26rem;
  color:#666;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after
{opacity:0;}
</style>


// WEBPACK FOOTER //
// src/ivew/home.vue